import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PipelinesList from './components/Pipelines/PipelinesList';
import Performance from './components/Performance/Performance';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import {
  faArrowsRotate,
  faArrowUpRightFromSquare,
  faCodeMerge,
  faClockRotateLeft,
  faCircleHalfStroke,
  faHourglassHalf,
  faCircleExclamation,
  faBan,
  faCirclePlay,
  faCircle,
  faCircleDot,
  faCirclePlus,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faStop,
  faCaretDown,
  faCaretUp,
  faLayerGroup,
  faCube,
  faVial,
  faTriangleExclamation
} from "@fortawesome/free-solid-svg-icons";
import { faFileLines, faClock, faCirclePause, faCircleStop, faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './scss/App.scss';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Sidebar from './components/Layouts/Sidebar';
import Wrapper from './components/Layouts/Wrapper';
import Section from './components/Layouts/Section';
import { ButtonGroup, Col, Container, Navbar, Pagination, Row, Alert, Toast, ToastContainer } from 'react-bootstrap';
import ModalRunPipeline from './components/Layouts/Modals/ModalRunPipeline';
import { ModalContext } from './store/modal-context';
import constants from './store/constants.json';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import StatusBar from './components/Layouts/StatusBar';
import Reports from './components/Reports/Reports';
import moment from 'moment';

library.add(
  fab,
  faArrowsRotate,
  faArrowUpRightFromSquare,
  faCodeMerge,
  faClockRotateLeft,
  faFileLines,
  faCircleHalfStroke,
  faClock,
  faHourglassHalf,
  faCirclePause,
  faCircleExclamation,
  faCircleCheck,
  faCircle,
  faCircle,
  faCircleDot,
  faCirclePlay,
  faCircleStop,
  faBan,
  faCirclePlus,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faStop,
  faCaretDown,
  faCaretUp,
  faLayerGroup,
  faCube,
  faVial,
  faTriangleExclamation
);


// import axios from 'axios';

// Navigation component that can access location
const NavigationBar = ({ 
  isLoading, 
  show, 
  handleShowModal,
  fetchPipelinesHandler,
  autoRefresh,
  toggleAutoRefresh,
  refreshInterval,
  handleRefreshIntervalChange,
  runningOnly,
  showRunningPipelines,
  successOnly,
  showSuccessPipelines,
  scheduleOnly,
  showSchedulePipelines,
  webOnly,
  showWebPipelines,
  pipelines,
  limitInput,
  limit,
  handleSetLimit,
  pageNumber,
  pagesOffset,
  setPageNumber,
  handlePageNumberDown,
  handlePageNumberUp,
  // Reports props
  selectedDate,
  setSelectedDate,
  reportDate,
  filteredPipelines,
  reportLoading,
  onReportRefresh
}) => {
  const location = useLocation();
  const isReportsPage = location.pathname === '/reports';

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleRefresh = () => {
    onReportRefresh(moment(selectedDate));
  };

  return (
    <Navbar expand="lg" sticky="top" className="bg-body-tertiary py-2">
      <Container>
        <Section className="actions text-center">
          <Row>
            {!isReportsPage && (
              <>
                <Col className="col-auto col-lg-2 col-xl-4">
                  <Row className="justify-content-start">
                    <Col xs={"auto"}>
                      {isLoading ? (
                        ""
                      ) : (
                        <Button
                          variant={`${!show ? "outline-" : ""}success`}
                          size="sm"
                          onClick={handleShowModal}
                          title="Run pipeline"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-circle-plus"
                            size="sm"
                          />
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col className="justify-content-lg-center col-auto col-lg-5">
                  <Button
                    variant="outline-primary"
                    onClick={fetchPipelinesHandler}
                    size="sm"
                    title="Update pipelines"
                    className="mx-1"
                  >
                    {isLoading ? (
                      <FontAwesomeIcon
                        icon="fa-solid fa-arrows-rotate"
                        size="sm"
                        spin
                      />
                    ) : (
                      <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                    )}
                  </Button>

                  {/* Auto-refresh toggle */}
                  <Button
                    variant={autoRefresh ? "success" : "outline-secondary"}
                    size="sm"
                    onClick={toggleAutoRefresh}
                    className="mx-1"
                    title={autoRefresh ? "Auto-refresh on" : "Auto-refresh off"}
                  >
                    <FontAwesomeIcon 
                      icon="fa-solid fa-clock-rotate-left"
                      size="sm"
                      spin={autoRefresh}
                    />
                  </Button>

                  {/* Refresh interval dropdown */}
                  {autoRefresh && (
                    <Form.Select 
                      size="sm" 
                      style={{width: 'auto', display: 'inline-block'}}
                      className="mx-1" 
                      value={refreshInterval / 1000}
                      onChange={(e) => handleRefreshIntervalChange(parseInt(e.target.value))}
                      title="Auto-refresh interval"
                      defaultValue="900"
                    >
                      <option value="60">1m</option>
                      <option value="120">2m</option>
                      <option value="300">5m</option>
                      <option value="600">10m</option>
                      <option value="900">15m</option>
                      <option value="1800">30m</option>
                    </Form.Select>
                  )}

                  {isLoading ? (
                    ""
                  ) : (
                    <ButtonGroup aria-label="Status switcher" className="mx-1">
                      <Button
                        variant={`${!runningOnly ? "outline-" : ""}info`}
                        className={`${runningOnly ? "text-white" : ""}`}
                        onClick={showRunningPipelines}
                        size="sm"
                        title="Running pipelines"
                      >
                        {(pipelines.length > 0)
                          ? <FontAwesomeIcon
                            icon="fa-solid fa-circle-play"
                            size="sm"
                          />
                          : <FontAwesomeIcon
                            icon="fa-solid fa-circle-play"
                            size="sm"
                            beatFade
                          />
                        }
                      </Button>

                      <Button
                        variant={`${!successOnly ? "outline-" : ""}info`}
                        className={`${successOnly ? "text-white" : ""}`}
                        onClick={showSuccessPipelines}
                        size="sm"
                        title="Success pipelines"
                      >
                        {(pipelines.length > 0)
                          ? <FontAwesomeIcon
                            icon="fa-regular fa-circle-check"
                            size="sm"
                          />
                          : <FontAwesomeIcon
                            icon="fa-regular fa-circle-check"
                            size="sm"
                            beatFade
                          />
                        }
                      </Button>
                    </ButtonGroup>
                  )}

                  {isLoading ? (
                    ""
                  ) : (
                    <ButtonGroup aria-label="Sources switcher" className="mx-1">
                      <Button
                        variant={`${!scheduleOnly ? "outline-" : ""}info`}
                        className={`${scheduleOnly ? "text-white" : ""}`}
                        onClick={showSchedulePipelines}
                        size="sm"
                        title="Schedule pipelines"
                      >
                      {(pipelines.length > 0)
                        ? <FontAwesomeIcon
                          icon="fa-solid fa-clock-rotate-left"
                          size="sm"
                        />
                        : <FontAwesomeIcon
                          icon="fa-solid fa-clock-rotate-left"
                          size="sm"
                          beatFade
                        />
                      }
                      </Button>

                      <Button
                        variant={`${!webOnly ? "outline-" : ""}info`}
                        className={`${webOnly ? "text-white" : ""}`}
                        onClick={showWebPipelines}
                        size="sm"
                        title="Branche Only pipelines"
                      >
                      {(pipelines.length > 0)
                        ? <FontAwesomeIcon
                          icon="fa-solid fa-code-merge"
                          size="sm"
                        />
                        : <FontAwesomeIcon
                          icon="fa-solid fa-code-merge"
                          size="sm"
                          beatFade
                        />
                      }
                      </Button>
                    </ButtonGroup>
                  )}
                </Col>

                <Col>
                  <Row className="justify-content-end">
                    {isLoading ? (
                      ""
                    ) : (
                      <>
                        <Col xs={"auto"}>
                          <InputGroup
                            className="limit"
                          >
                            <Form.Control
                              className="form-control input__limit"
                              ref={limitInput}
                              defaultValue={limit}
                              type="number"
                              width="50"
                              aria-label="Items quatity"
                              aria-describedby="btnGroupAddon"
                            />
                            <Button
                              type="submit"
                              value="Submit"
                              size="sm"
                              onClick={handleSetLimit}
                            >
                              Set limit
                            </Button>
                          </InputGroup>
                        </Col>

                        <Col
                          xs={"auto"}
                          className="d-flex justify-content-end align-items-center text-xs"
                        >
                          <Pagination
                            size="sm"
                          >
                            {pageNumber > pagesOffset &&
                              <>
                                <Pagination.Item
                                  onClick={() => {setPageNumber(1)}}
                                >1
                                </Pagination.Item>

                                <Pagination.First
                                  onClick={() => {setPageNumber((pageNumber - 3))}}
                                />
                              </>
                            }
                            
                            {pageNumber > 1 &&
                              <Pagination.Prev
                                onClick={handlePageNumberDown}
                              />
                            }
                            
                            {[...Array(pageNumber + pagesOffset)]
                              .map((elementInArray, index) =>
                                index >= pageNumber - pagesOffset &&
                                index < pageNumber + pagesOffset - 1 && (
                                  <Pagination.Item
                                    active={pageNumber === index + 1}
                                    key={index}
                                    onClick={() => {setPageNumber(index + 1)}}
                                  >
                                    {index + 1}
                                  </Pagination.Item>
                                )
                              )
                            }
                            
                            <Pagination.Next
                              onClick={handlePageNumberUp}
                            />

                            <Pagination.Last
                              onClick={() => {setPageNumber((pageNumber + 3))}}
                            />
                          </Pagination>
                        </Col>
                      </>
                    )}
                  </Row>
                </Col>
              </>
            )}

            {/* Reports page navigation */}
            {isReportsPage && (
              <>
                <Col xs={12} className="mb-2">
                  <Row className="align-items-center">
                    <Col xs="auto">
                      <Form.Group controlId="reportDate" className="mb-0">
                        <Form.Control 
                          type="date" 
                          value={selectedDate} 
                          onChange={handleDateChange} 
                          max={moment().format('YYYY-MM-DD')} 
                          size="sm"
                          style={{ width: '140px' }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs="auto">
                      <Button 
                        variant="outline-primary" 
                        onClick={handleRefresh} 
                        size="sm"
                        disabled={reportLoading}
                        className="px-2"
                      >
                        <FontAwesomeIcon 
                          icon="fa-solid fa-arrows-rotate" 
                          size="xs"
                          spin={reportLoading}
                        />
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </>
            )}
          </Row>
        </Section>
      </Container>
    </Navbar>
  );
};

function App() {
  // Use environment variables for credentials
  const gitlabProjectsUrl = window.env?.REACT_APP_GITLAB_PROJECTS_URL || process.env.REACT_APP_GITLAB_PROJECTS_URL || 'https://gitlab.devpayever.com/api/v4/projects/';
  const gitlabUrlAutomation = window.env?.REACT_APP_GITLAB_AUTOMATION_URL || process.env.REACT_APP_GITLAB_AUTOMATION_URL || `https://gitlab.devpayever.com/api/v4/projects/453`;
  // const gitlabUrl = 'https://gitlab.devpayever.com/api/v4/projects/453'
  // const gitlabUrl = 'https://gitlab.devpayever.com/api/v4/projects/qa%2Fautomation/pipelines?per_page=100'
  const PAT = 'glpat-teEmxgkyy6FvWApYvyDL';
  // const PAT = window.env?.REACT_APP_GITLAB_PAT || (process.env.REACT_APP_GITLAB_PAT ? process.env.REACT_APP_GITLAB_PAT.trim() : '');
  const [patValid, setPatValid] = useState(true);

  const limitInput = useRef();
  const [pipelines, setPipelines] = useState([]);
  // const [page, setPage] = useState(1);
  // const [jobs, setJobs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  // const [pipelineGroups, setPipelineGroups] = useState([]);
  const [runningOnly, setRunningOnly] = useState(true);
  const [successOnly, setSuccessOnly] = useState(false);
  const [filterBySource, setFilterBySource] = useState('');
  const [scheduleOnly, setScheduleOnly] = useState(true);
  const [webOnly, setWebOnly] = useState(true);
  // const [iconProps, setIconProps] = useState({});
  const [show, setShow] = useState(false);
  const [limit, setLimit] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [runningJobs, setRunningJobs] = useState(0);
  const [runningPipelines, setRunningPipelines] = useState(0);
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [refreshInterval, setRefreshInterval] = useState(900000); // Default to 15 minutes (900 seconds)
  const [lastRefreshed, setLastRefreshed] = useState(null);

  // Reports-specific state
  const [reportDate, setReportDate] = useState(moment().subtract(1, 'days'));
  const [selectedDate, setSelectedDate] = useState(moment().subtract(1, 'days').format('YYYY-MM-DD'));
  const [filteredPipelines, setFilteredPipelines] = useState([]);
  const [reportLoading, setReportLoading] = useState(false);
  const [reportRefreshTrigger, setReportRefreshTrigger] = useState(0);

  // Toast notifications
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('info');

  const pagesOffset = constants.setup.pagesOffset;
  const pipelineGroups = constants.groups;

  // Cache API fetch calls to avoid redundant requests
  const apiCache = useRef(new Map());

  // Create a utility function for fetching with caching
  const fetchWithCache = useCallback(async (url, options = {}) => {
    const cacheKey = url + JSON.stringify(options);
    
    // Check if we have cached data that's less than 2 minutes old (increased from 30s)
    if (apiCache.current.has(cacheKey)) {
      const cachedData = apiCache.current.get(cacheKey);
      const currentTime = new Date().getTime();
      if (currentTime - cachedData.timestamp < 120000) { // 2 minutes cache
        return cachedData.data;
      }
    }
    
    // If no cache or it's old, perform the fetch
    const response = await fetch(url, options);
    if (!response.ok) {
      // Handle authentication errors specially
      if (response.status === 401) {
        setPatValid(false);
        throw new Error('Authentication failed: Invalid or expired GitLab PAT');
      }
      throw new Error(`API error: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Update cache
    apiCache.current.set(cacheKey, {
      data,
      timestamp: new Date().getTime()
    });
    
    return data;
  }, []);

  // Create a batch fetcher for multiple requests of the same type
  const batchFetch = useCallback(async (urlFn, idList, options = {}) => {
    // Create chunks of 5 to limit concurrent requests
    const chunks = [];
    for (let i = 0; i < idList.length; i += 5) {
      chunks.push(idList.slice(i, i + 5));
    }

    const results = {};
    
    // Process each chunk sequentially to avoid overloading the API
    for (const chunk of chunks) {
      const chunkPromises = chunk.map(id => 
        fetchWithCache(urlFn(id), options)
          .then(data => {
            results[id] = data;
            return data;
          })
          .catch(error => {
            console.error(`Error fetching data for ID ${id}:`, error);
            results[id] = null;
            return null;
          })
      );
      
      await Promise.all(chunkPromises);
    }
    
    return results;
  }, [fetchWithCache]);

  // These functions are kept for potential future use
  // eslint-disable-next-line no-unused-vars
  const getPipelineDetails = useCallback(async (id) => {
    return fetchWithCache(`${gitlabUrlAutomation}/pipelines/${id}`, {
      headers: {
        'PRIVATE-TOKEN': PAT,
        'Accept': 'application/json',
      }
    });
  }, [fetchWithCache, gitlabUrlAutomation, PAT]);

  // eslint-disable-next-line no-unused-vars
  const getPipelineVariables = useCallback(async (id) => {
    return fetchWithCache(`${gitlabUrlAutomation}/pipelines/${id}/variables`, {
      headers: {
        'PRIVATE-TOKEN': PAT,
        'Accept': 'application/json',
      }
    });
  }, [fetchWithCache, gitlabUrlAutomation, PAT]);

  // Batch version for multiple pipelines
  const getBatchPipelineDetails = useCallback((pipelineIds) => {
    return batchFetch(
      id => `${gitlabUrlAutomation}/pipelines/${id}`,
      pipelineIds,
      {
        headers: {
          'PRIVATE-TOKEN': PAT,
          'Accept': 'application/json',
        }
      }
    );
  }, [batchFetch, gitlabUrlAutomation, PAT]);

  const getBatchPipelineVariables = useCallback((pipelineIds) => {
    return batchFetch(
      id => `${gitlabUrlAutomation}/pipelines/${id}/variables`,
      pipelineIds,
      {
        headers: {
          'PRIVATE-TOKEN': PAT,
          'Accept': 'application/json',
        }
      }
    );
  }, [batchFetch, gitlabUrlAutomation, PAT]);

  // const getPipelineReport = useCallback(async (id) => {
  //   return fetch(`${gitlabUrlAutomation}/${id}/test_report_summary`, {
  //     headers: {
  //       'PRIVATE-TOKEN': PAT,
  //       'Accept': 'application/json',
  //     }}).then((response) => response.json());
  // }, []);

  const getQaPipeline = useCallback(async (id) => {
    return fetchWithCache(`${gitlabUrlAutomation}/pipelines/${id}/bridges?downstream_pipeline=true`, {
      headers: {
        'PRIVATE-TOKEN': PAT,
        'Accept': 'application/json',
      }
    });
  }, [fetchWithCache, gitlabUrlAutomation, PAT]);

  const getPipelineJobs = useCallback(async (id, page = 1) => {
    return fetchWithCache(`${gitlabUrlAutomation}/pipelines/${id}/jobs?page=${page}&per_page=100`, {
      headers: {
        'PRIVATE-TOKEN': PAT,
        'Accept': 'application/json',
      }
    });
  }, [fetchWithCache, gitlabUrlAutomation, PAT]);

  // Add back the getJobMochawesome function to fetch test reports
  const getJobMochawesome = useCallback(async (jobId) => {
    return fetch(`${gitlabUrlAutomation}/jobs/${jobId}/artifacts/mochawesome-report/mochawesome.json`, {
      headers: {
        'PRIVATE-TOKEN': PAT,
        'Accept': 'application/json',
      }
    })
    .then((response) => response && response.ok && response.json())
    .catch(error => {
      console.log(`Failed to fetch mochawesome for job ${jobId}:`, error);
      return null;
    });
  }, [gitlabUrlAutomation, PAT]);

  // Batch updates to pipelines to reduce render cycles
  const updatePipelinesWithDetails = useCallback((id, newData) => {
    setPipelines(prevState => 
      prevState.map(pipeline => 
        pipeline.id === id ? { ...pipeline, ...newData } : pipeline
      )
    );
  }, []);

  // Batch update multiple pipelines at once
  const batchUpdatePipelines = useCallback((updatesMap) => {
    setPipelines(prevState => 
      prevState.map(pipeline => 
        updatesMap[pipeline.id] ? { ...pipeline, ...updatesMap[pipeline.id] } : pipeline
      )
    );
  }, []);

  // Optimized batch processing for multiple pipelines
  const batchProcessPipelines = useCallback(async (pipelines) => {
    try {
      // Extract all pipeline IDs
      const pipelineIds = pipelines.map(p => p.id);
      
      // Fetch all pipeline details and variables in a batch
      const [detailsMap, variablesMap] = await Promise.all([
        getBatchPipelineDetails(pipelineIds),
        getBatchPipelineVariables(pipelineIds)
      ]);
      
      // First batch update with details and variables
      const batchUpdates = {};
      
      for (const pipeline of pipelines) {
        const id = pipeline.id;
        if (detailsMap[id]) {
          batchUpdates[id] = { details: detailsMap[id] };
        }
        
        if (variablesMap[id]) {
          let variables = {};
          const filteredVariables = variablesMap[id].filter(
            variable =>
              variable.key === "CI_GROUP" ||
              variable.key === "DOMAIN_TEST" ||
              variable.key === "MICRO_URL_FRONTEND_COMMERCEOS" ||
              variable.key === "IN_PIPELINE_TYPE" ||
              variable.key === "PIPELINE_DESC"
          );

          filteredVariables.forEach(variable => {
            variables[variable.key] = variable.value;
          });
          
          batchUpdates[id] = { ...(batchUpdates[id] || {}), ...variables };
        }
      }
      
      // Apply the first batch of updates
      if (Object.keys(batchUpdates).length > 0) {
        batchUpdatePipelines(batchUpdates);
      }
      
      // Process all pipelines to count running jobs
      const allPipelines = pipelines;
      // console.log('Pipelines to process:', allPipelines.length);
      const runningJobsCounts = [];
      
      // Process in batches to avoid overloading the API
      const batchSize = 3;
      for (let i = 0; i < allPipelines.length; i += batchSize) {
        const batch = allPipelines.slice(i, i + batchSize);
        const batchPromises = batch.map(async (pipeline) => {
          try {
            const qaPipelineData = await getQaPipeline(pipeline.id);
            // console.log(`Pipeline ${pipeline.id} QA data:`, qaPipelineData);
            
            if (qaPipelineData && qaPipelineData.length > 0) {
            let qa = {
                qa_pipeline: qaPipelineData[0].downstream_pipeline,
              jobs: '',
                runningJobsCount: 0
            };

            if (qa.qa_pipeline && !['failed', 'canceled'].includes(qa.qa_pipeline.status)) {
                // Fetch jobs for multiple pages to get a complete picture
                let allJobs = [];
                let runningJobsTemp = 0;
                
                // Fetch up to 4 pages of jobs to ensure we get a complete picture
                for (let page = 1; page <= 4; page++) {
                  try {
                    const pageJobs = await getPipelineJobs(qa.qa_pipeline.id, page);
                    if (!pageJobs || pageJobs.length === 0) break; // No more jobs
                    
                    // Process mochawesome reports for completed jobs
                    for (let job of pageJobs) {
                      if (job.duration && job.status !== 'running') {
                        try {
                          const mocha = await getJobMochawesome(job.id);
                          if (mocha) job.mochawesome = mocha;
                        } catch (error) {
                          console.error(`Error fetching mochawesome for job ${job.id}:`, error);
                        }
                      }
                    }
                    
                    allJobs = [...allJobs, ...pageJobs];
                    
                    // Count running jobs on this page
                    const pageRunningJobs = pageJobs.filter(job => job.status === 'running').length;
                    runningJobsTemp += pageRunningJobs;
                    
                    if (pageJobs.length < 100) break; // If we got less than a full page, we're done
                  } catch (error) {
                    console.error(`Error fetching jobs page ${page} for pipeline ${qa.qa_pipeline.id}:`, error);
                    break;
                  }
                }
                
                // Update the qa object with all the jobs we found
                qa.runningJobsCount = runningJobsTemp;
                qa.jobs = { 
                  pipelineJobs: allJobs,
                  hasMoreJobs: allJobs.length >= 400, // If we got 4 full pages, there might be more
                  loadedPages: [1, 2, 3, 4].slice(0, Math.ceil(allJobs.length / 100)),
                  groups: [...new Set(allJobs.map(x => x.stage))]
                };
                
                // Update individual pipeline with qa data
                updatePipelinesWithDetails(pipeline.id, qa);
                
                // Return running jobs count for this pipeline
                return runningJobsTemp;
              }
            }
            return 0;
          } catch (error) {
            console.error(`Error processing QA pipeline for ${pipeline.id}:`, error);
            return 0;
          }
        });
        
        // Process each batch sequentially
        const batchCounts = await Promise.all(batchPromises);
        runningJobsCounts.push(...batchCounts);
      }
      
      return runningJobsCounts.reduce((total, count) => total + (count || 0), 0);
    } catch (error) {
      console.error('Error in batch processing pipelines:', error);
      return 0;
    }
  }, [getBatchPipelineDetails, getBatchPipelineVariables, getQaPipeline, getPipelineJobs, getJobMochawesome, batchUpdatePipelines, updatePipelinesWithDetails]);

  // Show toast notification
  const showNotification = useCallback((message, variant = 'info') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);
  }, []);

  const fetchPipelinesHandler = useCallback(async () => {
    if (!patValid) {
      setError('GitLab PAT is missing or invalid. Please check your environment variables.');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      // Build query params more efficiently
      const queryParams = new URLSearchParams();
      queryParams.append('per_page', limit);
      queryParams.append('page', pageNumber);
      
      if (runningOnly) {
        queryParams.append('status', 'running');
      }
      
      if (filterBySource) {
        queryParams.append('source', filterBySource);
      }
      
      const response = await fetch(`${gitlabUrlAutomation}/pipelines?${queryParams.toString()}`, {
        headers: {
          'PRIVATE-TOKEN': PAT,
          'Accept': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Something went wrong! Try to update.');
      }
      
      let data = await response.json();

      if (successOnly) {
        data = data.filter(pipeline => !['canceled', 'skipped'].includes(pipeline.status));
      }

      // Show pipelines immediately without details to improve perceived performance
      setPipelines(data);
      const runningCount = data.filter(pipeline => pipeline.status === 'running').length;
      
      // Check if we're filtering for running pipelines but none were found
      if (runningOnly && runningCount === 0) {
        // Turn off the running filter
        setRunningOnly(false);
        
        // Show notification
        showNotification('No running pipelines available. Filter turned off.', 'warning');
        
        // Refetch without the running filter
        const allQueryParams = new URLSearchParams();
        allQueryParams.append('per_page', limit);
        allQueryParams.append('page', pageNumber);
        
        if (filterBySource) {
          allQueryParams.append('source', filterBySource);
        }
        
        const allResponse = await fetch(`${gitlabUrlAutomation}/pipelines?${allQueryParams.toString()}`, {
          headers: {
            'PRIVATE-TOKEN': PAT,
            'Accept': 'application/json',
          }
        });
        
        if (allResponse.ok) {
          let allData = await allResponse.json();
          
          if (successOnly) {
            allData = allData.filter(pipeline => !['canceled', 'skipped'].includes(pipeline.status));
          }
          
          setPipelines(allData);
          data = allData;
        }
      }
      
      setRunningPipelines(runningCount);
      
      // Then load detailed information in the background
      const totalRunningJobs = await batchProcessPipelines(data);
      console.log('Total running jobs counted:', totalRunningJobs);
      console.log('Running pipelines count:', runningCount);
      console.log('Data retrieved:', data);
      setRunningJobs(totalRunningJobs);
      
      // Update the last refreshed timestamp
      setLastRefreshed(new Date());
      
      // Call all job checkers to ensure warnings are displayed
      setTimeout(() => {
        if (window.jobCheckers) {
          console.log('Calling all job checkers after fetch');
          Object.values(window.jobCheckers).forEach(checker => {
            if (typeof checker === 'function') {
              checker();
            }
          });
        }
      }, 300);
      
    } catch (error) {
      setError(error.message);
    } finally {
    setIsLoading(false);
    }
  }, [limit, pageNumber, runningOnly, successOnly, filterBySource, gitlabUrlAutomation, PAT, patValid, batchProcessPipelines, showNotification]);
  
  const handleSetLimit = useCallback(() => {
    setLimit(Number(limitInput.current.value));
  }, []);

  const showRunningPipelines = useCallback(() => {
    setRunningOnly(prev => !prev);
  }, []);
  
  const showSuccessPipelines = useCallback(() => {
    setSuccessOnly(prev => !prev);
  }, []);
  
  const showSchedulePipelines = useCallback(() => {
    if (scheduleOnly === webOnly) {
      setScheduleOnly(true);
      setWebOnly(false);
      setFilterBySource('schedule');
    } else {
      setScheduleOnly(prev => !prev);
      setFilterBySource('');
    }
  }, [scheduleOnly, webOnly]);
  
  const showWebPipelines = useCallback(() => {
    if (scheduleOnly === webOnly) {
      setWebOnly(true);
      setScheduleOnly(false);
      setFilterBySource('web');
    } else {
      setWebOnly(prev => !prev);
      setFilterBySource('');
    }
  }, [scheduleOnly, webOnly]);

  const handlePageNumberDown = useCallback(() => {
    setPageNumber(prev => (prev > 1 ? prev - 1 : 1));
  }, []);
  
  const handlePageNumberUp = useCallback(() => {
    setPageNumber(prev => prev + 1);
  }, []);

  const handleCloseModal = useCallback(() => setShow(false), []);
  const handleShowModal = useCallback(() => setShow(true), []);

  const toggleAutoRefresh = useCallback(() => {
    setAutoRefresh(prev => !prev);
  }, []);

  const handleRefreshIntervalChange = useCallback((seconds) => {
    setRefreshInterval(seconds * 1000);
  }, []);

  // Silent fetch function for running pipelines only
  const silentFetchRunningPipelines = useCallback(async () => {
    if (!patValid || isLoading) {
      return; // Don't fetch if PAT is invalid or if already loading
    }

    try {
      // Get current running pipelines from state
      const currentRunningPipelines = pipelines.filter(pipeline => pipeline.status === 'running');
      
      if (currentRunningPipelines.length === 0) {
        return; // No running pipelines to update
      }

      console.log(`Silent fetch: Updating ${currentRunningPipelines.length} running pipelines and their jobs`);

      // Fetch updated data for each running pipeline
      const runningPipelineIds = currentRunningPipelines.map(p => p.id);
      const updatedPipelineDetails = await getBatchPipelineDetails(runningPipelineIds);

      // Process each running pipeline to update both pipeline and job data
      let totalRunningJobsChange = 0;
      const pipelinesNeedingFullRefresh = [];
      let stillRunningCount = 0;
      
      for (const pipeline of currentRunningPipelines) {
        const updatedPipeline = updatedPipelineDetails[pipeline.id];
        
        if (updatedPipeline) {
          // Check if pipeline is still running
          if (updatedPipeline.status === 'running') {
            stillRunningCount++;
          }
          
          // Check if pipeline status changed from 'running' to something else
          const statusChanged = pipeline.status === 'running' && updatedPipeline.status !== 'running';
          
          if (statusChanged) {
            console.log(`Silent update: Pipeline ${pipeline.id} finished - status changed from ${pipeline.status} to ${updatedPipeline.status}. Scheduling full refresh.`);
            pipelinesNeedingFullRefresh.push(pipeline.id);
            continue; // Skip partial update, will do full refresh
          }

          let pipelineUpdate = {
            status: updatedPipeline.status,
            updated_at: updatedPipeline.updated_at,
            finished_at: updatedPipeline.finished_at,
            duration: updatedPipeline.duration,
            details: updatedPipeline,
          };

          // If pipeline has QA pipeline and jobs, update running jobs
          if (pipeline.qa_pipeline && pipeline.jobs && pipeline.jobs.pipelineJobs) {
            try {
              // Fetch updated jobs for the QA pipeline
              const updatedJobs = await getPipelineJobs(pipeline.qa_pipeline.id, 1);
              
              if (updatedJobs && updatedJobs.length > 0) {
                // Get existing jobs data
                const existingJobs = pipeline.jobs.pipelineJobs;
                const existingJobsMap = new Map(existingJobs.map(job => [job.id, job]));
                
                // Update existing jobs with new status information
                const updatedJobsList = existingJobs.map(existingJob => {
                  const updatedJob = updatedJobs.find(newJob => newJob.id === existingJob.id);
                  if (updatedJob) {
                    // Only update if status has changed
                    if (updatedJob.status !== existingJob.status) {
                      console.log(`Silent update: Job ${existingJob.id} status changed from ${existingJob.status} to ${updatedJob.status}`);
                      return {
                        ...existingJob,
                        status: updatedJob.status,
                        started_at: updatedJob.started_at,
                        finished_at: updatedJob.finished_at,
                        duration: updatedJob.duration,
                        // Preserve mochawesome and other existing data
                      };
                    }
                  }
                  return existingJob;
                });

                // Add any new jobs that weren't in the existing list
                const newJobs = updatedJobs.filter(newJob => !existingJobsMap.has(newJob.id));
                const allUpdatedJobs = [...updatedJobsList, ...newJobs];

                // Calculate running jobs count change
                const oldRunningCount = existingJobs.filter(job => job.status === 'running').length;
                const newRunningCount = allUpdatedJobs.filter(job => job.status === 'running').length;
                const runningJobsChange = newRunningCount - oldRunningCount;
                totalRunningJobsChange += runningJobsChange;

                // Update pipeline with new jobs data
                pipelineUpdate.jobs = {
                  ...pipeline.jobs,
                  pipelineJobs: allUpdatedJobs,
                  groups: [...new Set(allUpdatedJobs.map(x => x.stage))]
                };
                pipelineUpdate.runningJobsCount = newRunningCount;

                console.log(`Silent update: Pipeline ${pipeline.id} running jobs: ${oldRunningCount} → ${newRunningCount} (change: ${runningJobsChange})`);
              }
            } catch (jobError) {
              console.error(`Silent fetch: Error updating jobs for pipeline ${pipeline.id}:`, jobError);
              // Continue with pipeline update even if job update fails
            }
          }

          // Update the pipeline in state
          setPipelines(prevPipelines => {
            return prevPipelines.map(p => {
              if (p.id === pipeline.id) {
                // Only update if there are actual changes
                const hasChanges = 
                  p.status !== pipelineUpdate.status ||
                  p.updated_at !== pipelineUpdate.updated_at ||
                  (pipelineUpdate.jobs && JSON.stringify(p.jobs) !== JSON.stringify(pipelineUpdate.jobs));
                
                if (hasChanges) {
                  console.log(`Silent update: Pipeline ${pipeline.id} status: ${p.status} → ${pipelineUpdate.status}`);
                  
                  // Call job checkers for updated jobs after change
                  setTimeout(() => {
                    if (window.jobCheckers && pipelineUpdate.jobs && pipelineUpdate.jobs.pipelineJobs) {
                      pipelineUpdate.jobs.pipelineJobs.forEach(job => {
                        if (window.jobCheckers[job.id]) {
                          console.log(`Calling job checker for job ${job.id}`);
                          window.jobCheckers[job.id]();
                        }
                      });
                    }
                  }, 100);
                  
                  return { ...p, ...pipelineUpdate };
                }
              }
              return p;
            });
          });
        }
      }

      // Check if all running pipelines have completed
      if (stillRunningCount === 0 && currentRunningPipelines.length > 0 && runningOnly) {
        // Turn off running filter since no pipelines are running anymore
        setRunningOnly(false);
        showNotification(`All pipelines have completed. Running filter turned off.`, 'success');
        
        // Refetch without the running filter to show all pipelines
        fetchPipelinesHandler();
      } else {
        // Update running pipelines count
        setRunningPipelines(stillRunningCount);
      }

      // Perform full refresh for pipelines that finished
      if (pipelinesNeedingFullRefresh.length > 0) {
        console.log(`Silent update: Performing full refresh for ${pipelinesNeedingFullRefresh.length} finished pipelines`);
        
        try {
          // Get full pipeline data for finished pipelines
          const finishedPipelineDetails = await getBatchPipelineDetails(pipelinesNeedingFullRefresh);
          const finishedPipelineVariables = await getBatchPipelineVariables(pipelinesNeedingFullRefresh);
          
          // Process each finished pipeline with full data refresh
          for (const pipelineId of pipelinesNeedingFullRefresh) {
            const pipeline = currentRunningPipelines.find(p => p.id === pipelineId);
            if (!pipeline) continue;
            
            try {
              let fullPipelineUpdate = {
                status: finishedPipelineDetails[pipelineId]?.status || pipeline.status,
                updated_at: finishedPipelineDetails[pipelineId]?.updated_at || pipeline.updated_at,
                finished_at: finishedPipelineDetails[pipelineId]?.finished_at || pipeline.finished_at,
                duration: finishedPipelineDetails[pipelineId]?.duration || pipeline.duration,
                details: finishedPipelineDetails[pipelineId] || pipeline.details,
              };

              // Add variables if available
              if (finishedPipelineVariables[pipelineId]) {
                const variables = {};
                const filteredVariables = finishedPipelineVariables[pipelineId].filter(
                  variable =>
                    variable.key === "CI_GROUP" ||
                    variable.key === "DOMAIN_TEST" ||
                    variable.key === "MICRO_URL_FRONTEND_COMMERCEOS" ||
                    variable.key === "IN_PIPELINE_TYPE" ||
                    variable.key === "PIPELINE_DESC"
                );
                filteredVariables.forEach(variable => {
                  variables[variable.key] = variable.value;
                });
                fullPipelineUpdate = { ...fullPipelineUpdate, ...variables };
              }

              // Get QA pipeline and full jobs data
              const qaPipelineData = await getQaPipeline(pipelineId);
              if (qaPipelineData && qaPipelineData.length > 0) {
                let qa = {
                  qa_pipeline: qaPipelineData[0].downstream_pipeline,
                  jobs: '',
                  runningJobsCount: 0
                };

                if (qa.qa_pipeline && !['failed', 'canceled'].includes(qa.qa_pipeline.status)) {
                  // Fetch all jobs for the finished pipeline
                  let allJobs = [];
                  let runningJobsTemp = 0;
                  
                  // Fetch up to 4 pages of jobs to ensure we get complete data
                  for (let page = 1; page <= 4; page++) {
                    try {
                      const pageJobs = await getPipelineJobs(qa.qa_pipeline.id, page);
                      if (!pageJobs || pageJobs.length === 0) break;
                      
                      // Process mochawesome reports for completed jobs
                      for (let job of pageJobs) {
                        if (job.duration && job.status !== 'running') {
                          try {
                            const mocha = await getJobMochawesome(job.id);
                            if (mocha) job.mochawesome = mocha;
                          } catch (error) {
                            console.error(`Error fetching mochawesome for job ${job.id}:`, error);
                          }
                        }
                      }
                      
                      allJobs = [...allJobs, ...pageJobs];
                      
                      // Count running jobs on this page
                      const pageRunningJobs = pageJobs.filter(job => job.status === 'running').length;
                      runningJobsTemp += pageRunningJobs;
                      
                      if (pageJobs.length < 100) break;
                    } catch (error) {
                      console.error(`Error fetching jobs page ${page} for finished pipeline ${qa.qa_pipeline.id}:`, error);
                      break;
                    }
                  }
                  
                  qa.runningJobsCount = runningJobsTemp;
                  qa.jobs = { 
                    pipelineJobs: allJobs,
                    hasMoreJobs: allJobs.length >= 400,
                    loadedPages: [1, 2, 3, 4].slice(0, Math.ceil(allJobs.length / 100)),
                    groups: [...new Set(allJobs.map(x => x.stage))]
                  };
                  
                  // Update running jobs count change
                  const oldRunningCount = pipeline.runningJobsCount || 0;
                  const runningJobsChange = runningJobsTemp - oldRunningCount;
                  totalRunningJobsChange += runningJobsChange;
                  
                  console.log(`Full refresh: Pipeline ${pipelineId} final running jobs: ${runningJobsTemp} (change: ${runningJobsChange})`);
                }
                
                fullPipelineUpdate = { ...fullPipelineUpdate, ...qa };
              }

              // Update the pipeline with full data
              updatePipelinesWithDetails(pipelineId, fullPipelineUpdate);
              
            } catch (error) {
              console.error(`Error during full refresh for pipeline ${pipelineId}:`, error);
            }
          }
        } catch (error) {
          console.error('Error during full refresh of finished pipelines:', error);
        }
      }

      // Update total running jobs count
      if (totalRunningJobsChange !== 0) {
        setRunningJobs(prevCount => {
          const newCount = prevCount + totalRunningJobsChange;
          console.log(`Silent update: Total running jobs count changed by ${totalRunningJobsChange}: ${prevCount} → ${newCount}`);
          return newCount;
        });
      }

    } catch (error) {
      console.error('Silent fetch error (non-critical):', error);
      // Don't set error state for silent fetches to avoid disrupting UI
    }
  }, [patValid, isLoading, pipelines, getBatchPipelineDetails, getBatchPipelineVariables, getQaPipeline, getPipelineJobs, getJobMochawesome, updatePipelinesWithDetails, runningOnly, showNotification, fetchPipelinesHandler]);

  useEffect(() => {
    // Initial fetch
    fetchPipelinesHandler().catch(err => {
      console.error('Error during initial pipeline fetch:', err);
    });
    
    // Set up auto-refresh if enabled
    let intervalId;
    let consecutiveErrors = 0;
    const MAX_CONSECUTIVE_ERRORS = 3;
    
    if (autoRefresh) {
      intervalId = setInterval(async () => {
        try {
          console.log(`Auto-refreshing pipelines every ${refreshInterval/1000} seconds`);
          await fetchPipelinesHandler();
          // Reset error counter on success
          consecutiveErrors = 0;
        } catch (error) {
          consecutiveErrors++;
          console.error(`Auto-refresh error (${consecutiveErrors}/${MAX_CONSECUTIVE_ERRORS}):`, error);
          
          // If too many consecutive errors, disable auto-refresh
          if (consecutiveErrors >= MAX_CONSECUTIVE_ERRORS) {
            console.error('Too many consecutive errors. Auto-refresh disabled.');
            setAutoRefresh(false);
            setError('Auto-refresh disabled due to multiple consecutive errors. Please check your connection and try again.');
          }
        }
      }, refreshInterval);
    }
    
    // Clean up interval when component unmounts or dependencies change
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [fetchPipelinesHandler, autoRefresh, refreshInterval]);
  
  // Set up silent fetching for running pipelines (runs more frequently)
  useEffect(() => {
    let silentIntervalId;
    const SILENT_FETCH_INTERVAL = 30000; // 30 seconds for silent updates
    
    // Only run silent fetching if auto-refresh is enabled and we have pipelines
    if (autoRefresh && pipelines.length > 0) {
      silentIntervalId = setInterval(async () => {
        const runningCount = pipelines.filter(p => p.status === 'running').length;
        if (runningCount > 0) {
          console.log(`Silent fetch: Checking ${runningCount} running pipelines`);
          await silentFetchRunningPipelines();
        }
      }, SILENT_FETCH_INTERVAL);
    }
    
    // Clean up interval when component unmounts or dependencies change
    return () => {
      if (silentIntervalId) {
        clearInterval(silentIntervalId);
      }
    };
  }, [autoRefresh, pipelines.length, silentFetchRunningPipelines, pipelines]);
  
  // Memoize components to prevent unnecessary re-renders
  const pipelinesList = useMemo(() => {
    if (!pipelines.length) {
      return <p>Found no pipelines.</p>;
    }
    
    return (
    <PipelinesList
      pipelines={pipelines}
      runningOnly={runningOnly}
      filterBySource={filterBySource}
      />
    );
  }, [pipelines, runningOnly, filterBySource]);
  
  let content = pipelinesList;

  if (error) {
    content = <p>{error}</p>;
  }

  if (isLoading) {
    content =
    <Skeleton
      count={10}
      style={{
        // border: '1px solid #ccc',
        display: 'block',
        lineHeight: 1.4,
        padding: '0.75rem',
        // marginBottom: '0.1rem',
        // width: 100,
      }}
    />
    // content = <p>Loading...</p>
  }

  // Memoize the context value to prevent unnecessary re-renders
  const modalContextValue = useMemo(() => {
    // Structure the GitLab URL to include the project ID for API calls
    // The URL should be in the format: https://gitlab.example.com/api/v4/projects/123
    // This ensures the ModalRunPipeline component can properly append endpoints
    const projectId = 453; // The GitLab project ID
    
    return {
        showModal: show,
        handleShowModal: handleShowModal,
        handleCloseModal: handleCloseModal,
        groupsArray: Object.keys(pipelineGroups).map((group) => {
          let groupName = group.replace('-', ' ');
          groupName = (groupName.charAt(0)).toUpperCase() + groupName.slice(1);

          return {
            name: (groupName.charAt(0)).toUpperCase() + groupName.slice(1),
            value: pipelineGroups[group]
          };
        }),
      gitlabProjectsUrl,
      // This URL format ensures it works with the ModalRunPipeline component
      gitlabUrl: gitlabUrlAutomation,
      gitlabUrlAutomation,
      PAT,
      autoRefresh,
      toggleAutoRefresh,
      refreshInterval,
      handleRefreshIntervalChange,
      pipelines: { 
        project_id: projectId
      },
      onPipelineRun: fetchPipelinesHandler,
    };
  }, [show, handleShowModal, handleCloseModal, pipelineGroups, gitlabProjectsUrl, gitlabUrlAutomation, PAT, autoRefresh, toggleAutoRefresh, refreshInterval, handleRefreshIntervalChange, fetchPipelinesHandler]);

  // Add debug information in development mode
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Environment Configuration:');
      console.log('- REACT_APP_GITLAB_PROJECTS_URL:', process.env.REACT_APP_GITLAB_PROJECTS_URL ? 'Set' : 'Not set');
      console.log('- REACT_APP_GITLAB_AUTOMATION_URL:', process.env.REACT_APP_GITLAB_AUTOMATION_URL ? 'Set' : 'Not set');
      console.log('- REACT_APP_GITLAB_PAT:', process.env.REACT_APP_GITLAB_PAT ? 'Set (value hidden)' : 'Not set');
      console.log('- REACT_APP_BASENAME:', process.env.REACT_APP_BASENAME || '/');
      console.log('- PAT Valid:', patValid);
    }
  }, [patValid]);

  // Verify PAT is valid on component mount
  useEffect(() => {
    const validatePAT = async () => {
      if (!PAT) {
        console.error('PAT is empty or undefined');
        setPatValid(false);
        setError('GitLab PAT is missing. Please provide a valid token in the .env file.');
        return;
      }

      try {
        console.log(`Testing PAT validation with URL: ${gitlabProjectsUrl}453`);
        console.log(`PAT length: ${PAT.length}, first 4 chars: ${PAT.substring(0, 4)}...`);
        
        const response = await fetch(`${gitlabProjectsUrl}453`, {
          headers: {
            'PRIVATE-TOKEN': PAT,
            'Accept': 'application/json',
          }
        });
        
        if (!response.ok) {
          console.error(`PAT validation failed with status: ${response.status}`);
          setPatValid(false);
          setError(`GitLab PAT is invalid. Status: ${response.status}. Please check your token in the .env file.`);
        } else {
          console.log('PAT validation successful');
          setPatValid(true);
        }
      } catch (error) {
        console.error('PAT validation error:', error);
        setPatValid(false);
        setError('Failed to validate GitLab PAT. Please check your connection and token.');
      }
    };

    validatePAT();
  }, [PAT, gitlabProjectsUrl]);

  // Function to load more jobs for a specific pipeline
  const loadMoreJobs = useCallback(async (pipelineId, qaId, currentPages) => {
    if (!currentPages || !currentPages.length) return;
    
    try {
      // Get next page number
      const nextPage = Math.max(...currentPages) + 1;
      
      // Set loading state for this specific pipeline
      updatePipelinesWithDetails(pipelineId, { loadingMoreJobs: true });
      
      // Load the next page of jobs
      const nextPageJobs = await getPipelineJobs(qaId, nextPage);
      
      // Get current pipeline data
      const pipeline = pipelines.find(p => p.id === pipelineId);
      if (!pipeline || !pipeline.jobs) return;
      
      // Update jobs data
      const allJobs = [...pipeline.jobs.pipelineJobs, ...nextPageJobs];
      const uniqueJobsMap = new Map();
      
      // Remove duplicates
      allJobs.forEach(job => {
        if (job && job.id) {
          uniqueJobsMap.set(job.id, job);
        }
      });
      
      const uniqueJobs = Array.from(uniqueJobsMap.values());
      
      // Count running jobs
      const runningJobsCount = uniqueJobs.filter(job => job.status === 'running').length;
      
      // Update the pipeline with new job data
      updatePipelinesWithDetails(pipelineId, {
        loadingMoreJobs: false,
        runningJobsCount,
        jobs: {
          ...pipeline.jobs,
          pipelineJobs: uniqueJobs,
          hasMoreJobs: nextPageJobs.length === 100,
          loadedPages: [...pipeline.jobs.loadedPages, nextPage],
          groups: [...new Set(uniqueJobs.map(x => x.stage))]
        }
      });
      
      // Update total running jobs count
      const oldRunningCount = pipeline.runningJobsCount || 0;
      const diff = runningJobsCount - oldRunningCount;
      if (diff !== 0) {
        setRunningJobs(prev => prev + diff);
      }
      
    } catch (error) {
      console.error(`Error loading more jobs for pipeline ${pipelineId}:`, error);
      updatePipelinesWithDetails(pipelineId, { loadingMoreJobs: false });
    }
  }, [getPipelineJobs, pipelines, updatePipelinesWithDetails]);

  // Function to retry a job
  const retryJob = useCallback(async (jobId) => {
    try {
      console.log(`Retrying job ${jobId}`);
      const response = await fetch(`${gitlabUrlAutomation}/jobs/${jobId}/retry`, {
        method: 'POST',
        headers: {
          'PRIVATE-TOKEN': PAT,
          'Accept': 'application/json',
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`Error retrying job ${jobId}:`, errorText);
        throw new Error(`Failed to retry job: ${response.status} ${response.statusText}`);
      }

      // Get the new job data from response
      const newJob = await response.json();
      
      // Find which pipeline contains this job and update it silently
      setPipelines(prevPipelines => {
        return prevPipelines.map(pipeline => {
          // Skip if pipeline doesn't have jobs
          if (!pipeline.jobs || !pipeline.jobs.pipelineJobs) return pipeline;
          
          // Find if this job belongs to this pipeline
          const jobIndex = pipeline.jobs.pipelineJobs.findIndex(job => job.id === jobId);
          if (jobIndex === -1) return pipeline;
          
          // Create a copy of the jobs array
          const updatedJobs = [...pipeline.jobs.pipelineJobs];
          
          // Update the job with new status
          updatedJobs[jobIndex] = {
            ...updatedJobs[jobIndex],
            status: newJob.status || 'pending',
            retried: true
          };
          
          // Return the updated pipeline
          return {
            ...pipeline,
            jobs: {
              ...pipeline.jobs,
              pipelineJobs: updatedJobs
            }
          };
        });
      });
      
      return true;
    } catch (error) {
      console.error(`Error retrying job ${jobId}:`, error);
      return false;
    }
  }, [gitlabUrlAutomation, PAT]);

  // Function to cancel a job
  const cancelJob = useCallback(async (jobId) => {
    try {
      console.log(`Canceling job ${jobId}`);
      const response = await fetch(`${gitlabUrlAutomation}/jobs/${jobId}/cancel`, {
        method: 'POST',
        headers: {
          'PRIVATE-TOKEN': PAT,
          'Accept': 'application/json',
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`Error canceling job ${jobId}:`, errorText);
        throw new Error(`Failed to cancel job: ${response.status} ${response.statusText}`);
      }

      // Find which pipeline contains this job and update it silently
      setPipelines(prevPipelines => {
        return prevPipelines.map(pipeline => {
          // Skip if pipeline doesn't have jobs
          if (!pipeline.jobs || !pipeline.jobs.pipelineJobs) return pipeline;
          
          // Find if this job belongs to this pipeline
          const jobIndex = pipeline.jobs.pipelineJobs.findIndex(job => job.id === jobId);
          if (jobIndex === -1) return pipeline;
          
          // Create a copy of the jobs array
          const updatedJobs = [...pipeline.jobs.pipelineJobs];
          
          // Update the job with canceled status
          updatedJobs[jobIndex] = {
            ...updatedJobs[jobIndex],
            status: 'canceled'
          };
          
          // Return the updated pipeline
          return {
            ...pipeline,
            jobs: {
              ...pipeline.jobs,
              pipelineJobs: updatedJobs
            }
          };
        });
      });
      
      return true;
    } catch (error) {
      console.error(`Error canceling job ${jobId}:`, error);
      return false;
    }
  }, [gitlabUrlAutomation, PAT]);

  // Function to retry a pipeline
  const retryPipeline = useCallback(async (pipelineId) => {
    try {
      if (!pipelineId) {
        console.error('No pipeline ID provided for retry');
        return false;
      }
      
      console.log(`Retrying pipeline ${pipelineId}`);
      const response = await fetch(`${gitlabUrlAutomation}/pipelines/${pipelineId}/retry`, {
        method: 'POST',
        headers: {
          'PRIVATE-TOKEN': PAT,
          'Accept': 'application/json',
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`Error retrying pipeline ${pipelineId}:`, errorText);
        throw new Error(`Failed to retry pipeline: ${response.status} ${response.statusText}`);
      }

      // Get the retried pipeline data
      const retriedPipeline = await response.json();
      
      // Update pipeline status silently without refreshing the whole page
      setPipelines(prevPipelines => {
        return prevPipelines.map(pipeline => {
          // Check if this pipeline has a qa_pipeline with the matching ID
          if (pipeline.qa_pipeline && pipeline.qa_pipeline.id === pipelineId) {
            return {
              ...pipeline,
              qa_pipeline: {
                ...pipeline.qa_pipeline,
                status: retriedPipeline.status || 'pending',
                retried: true
              }
            };
          }
          return pipeline;
        });
      });
      
      return true;
    } catch (error) {
      console.error(`Error retrying pipeline ${pipelineId}:`, error);
      return false;
    }
  }, [gitlabUrlAutomation, PAT]);

  // Function to cancel a pipeline
  const cancelPipeline = useCallback(async (pipelineId) => {
    try {
      if (!pipelineId) {
        console.error('No pipeline ID provided for cancel');
        return false;
      }
      
      console.log(`Canceling pipeline ${pipelineId}`);
      const response = await fetch(`${gitlabUrlAutomation}/pipelines/${pipelineId}/cancel`, {
        method: 'POST',
        headers: {
          'PRIVATE-TOKEN': PAT,
          'Accept': 'application/json',
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`Error canceling pipeline ${pipelineId}:`, errorText);
        throw new Error(`Failed to cancel pipeline: ${response.status} ${response.statusText}`);
      }

      // Update pipeline status silently without refreshing the whole page
      setPipelines(prevPipelines => {
        return prevPipelines.map(pipeline => {
          // Check if this pipeline has a qa_pipeline with the matching ID
          if (pipeline.qa_pipeline && pipeline.qa_pipeline.id === pipelineId) {
            return {
              ...pipeline,
              qa_pipeline: {
                ...pipeline.qa_pipeline,
                status: 'canceled'
              }
            };
          }
          return pipeline;
        });
      });
      
      return true;
    } catch (error) {
      console.error(`Error canceling pipeline ${pipelineId}:`, error);
      return false;
    }
  }, [gitlabUrlAutomation, PAT]);

  // Expose loadMoreJobs and retryJob functions to window for access from components
  useEffect(() => {
    window.loadMoreJobs = loadMoreJobs;
    window.retryJob = retryJob;
    window.cancelJob = cancelJob;
    window.retryPipeline = retryPipeline;
    window.cancelPipeline = cancelPipeline;
    return () => {
      delete window.loadMoreJobs;
      delete window.retryJob;
      delete window.cancelJob;
      delete window.retryPipeline;
      delete window.cancelPipeline;
    };
  }, [loadMoreJobs, retryJob, cancelJob, retryPipeline, cancelPipeline]);

  // Handler for reports refresh from navigation
  const handleReportRefresh = useCallback((date) => {
    setReportDate(date);
    setSelectedDate(date.format('YYYY-MM-DD'));
    setReportRefreshTrigger(prev => prev + 1); // Trigger refresh in ReportsList
  }, []);

  return (
    <ModalContext.Provider value={modalContextValue}>
      <ModalRunPipeline />
      
      <Router basename={window.env?.REACT_APP_BASENAME || process.env.REACT_APP_BASENAME || "/"}>
        <Wrapper className="main">
          <Sidebar running={runningPipelines} total={limit} />
          <Wrapper className="content">
            <NavigationBar 
              isLoading={isLoading}
              show={show}
              handleShowModal={handleShowModal}
              fetchPipelinesHandler={fetchPipelinesHandler}
              autoRefresh={autoRefresh}
              toggleAutoRefresh={toggleAutoRefresh}
              refreshInterval={refreshInterval}
              handleRefreshIntervalChange={handleRefreshIntervalChange}
              runningOnly={runningOnly}
              showRunningPipelines={showRunningPipelines}
              successOnly={successOnly}
              showSuccessPipelines={showSuccessPipelines}
              scheduleOnly={scheduleOnly}
              showSchedulePipelines={showSchedulePipelines}
              webOnly={webOnly}
              showWebPipelines={showWebPipelines}
              pipelines={pipelines}
              limitInput={limitInput}
              limit={limit}
              handleSetLimit={handleSetLimit}
              pageNumber={pageNumber}
              pagesOffset={pagesOffset}
              setPageNumber={setPageNumber}
              handlePageNumberDown={handlePageNumberDown}
              handlePageNumberUp={handlePageNumberUp}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              reportDate={reportDate}
              filteredPipelines={filteredPipelines}
              reportLoading={reportLoading}
              onReportRefresh={handleReportRefresh}
            />

            <StatusBar 
              runningJobs={runningJobs} 
              runningPipelines={runningPipelines} 
              lastRefreshed={lastRefreshed} 
              reportDate={reportDate}
              filteredPipelines={filteredPipelines}
            />

            {!patValid && (
              <Container className="mt-3">
                <Alert variant="danger">
                  <Alert.Heading>Authentication Error</Alert.Heading>
                  <p>
                    GitLab Personal Access Token (PAT) is missing or invalid. The application needs a valid token to access GitLab API.
                  </p>
                  <hr />
                  <p className="mb-0">
                    Please check your environment variables and make sure REACT_APP_GITLAB_PAT is set correctly in your .env file or CI/CD variables.
                  </p>
                </Alert>
              </Container>
            )}

            <Routes>
              <Route path="/" element={
            <Container>
              <Wrapper className="pipelines">
                <Section className="pipelines-list text-center">
                  {content}
                </Section>
              </Wrapper>
            </Container>
              } />
              <Route path="/reports" element={
                <Reports 
                  reportDate={reportDate}
                  selectedDate={selectedDate}
                  filteredPipelines={filteredPipelines}
                  setFilteredPipelines={setFilteredPipelines}
                  setReportLoading={setReportLoading}
                  reportRefreshTrigger={reportRefreshTrigger}
                  reportLoading={reportLoading}
                />
              } />
              <Route path="/performance" element={
                <>
                  {console.log('[DEBUG] App.js passing pipelines to Performance:', pipelines)}
                  {console.log('[DEBUG] App.js pipelines length:', pipelines?.length)}
                  <Performance 
                    pipelines={pipelines}
                  />
                </>
              } />
            </Routes>
          </Wrapper>
        </Wrapper>
      </Router>

      {/* Toast notifications */}
      <ToastContainer 
        position="bottom-end" 
        className="p-3" 
        style={{ zIndex: 9999 }}
      >
        <Toast 
          onClose={() => setShowToast(false)} 
          show={showToast} 
          delay={10000} 
          autohide
          bg={toastVariant}
          className="text-white"
        >
          <Toast.Header closeButton>
            <strong className="me-auto">Pipeline Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </ModalContext.Provider>
  );
}

export default App;